var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton',{staticClass:"mb-3",attrs:{"height":"73px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }